import { useWorkbook } from "@/lib/workbook";

const LINE = { "h-5": 20, "h-6": 24, "h-7": 28 };

export const WbText = ({ k, n, h = "h-7" }) => {
  const { values, set, editable } = useWorkbook();
  const lh = LINE[h] || 28;
  return (
    <textarea
      data-testid={`wb-${k}`}
      readOnly={!editable}
      value={values[k] || ""}
      onChange={(e) => set(k, e.target.value)}
      className={`wb-lined block w-full resize-none overflow-hidden bg-transparent px-1 text-sm text-slate-900 outline-none ${editable ? "focus:bg-[#1F4266]/5" : "cursor-default"}`}
      style={{ height: n * lh, lineHeight: `${lh}px`, backgroundImage: `repeating-linear-gradient(to bottom, transparent 0, transparent ${lh - 1}px, #cbd5e1 ${lh - 1}px, #cbd5e1 ${lh}px)` }}
    />
  );
};

export const WbLine = ({ k, value, className = "" }) => {
  const { values, set, editable } = useWorkbook();
  if (value) return <span className={`flex-1 border-b border-slate-400 pb-0.5 text-sm font-semibold text-slate-900 ${className}`}>{value}</span>;
  return (
    <input
      data-testid={`wb-${k}`}
      readOnly={!editable}
      value={values[k] || ""}
      onChange={(e) => set(k, e.target.value)}
      className={`h-6 min-w-0 flex-1 border-b border-slate-400 bg-transparent px-1 text-sm text-slate-900 outline-none ${editable ? "focus:bg-[#1F4266]/5" : "cursor-default"} ${className}`}
    />
  );
};

export const WbRating = ({ k }) => {
  const { values, set, editable } = useWorkbook();
  return (
    <span className="flex gap-1" data-testid={`wb-${k}`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const on = Number(values[k]) === n;
        return (
          <button
            key={n}
            type="button"
            disabled={!editable}
            onClick={() => set(k, on ? "" : n)}
            data-testid={`wb-${k}-${n}`}
            className={`flex h-5 w-5 items-center justify-center rounded-full border text-[10px] ${on ? "border-[#1F4266] bg-[#1F4266] text-white" : "border-slate-400 text-slate-500"} ${editable ? "cursor-pointer hover:border-[#1F4266]" : "cursor-default"}`}
          >
            {n}
          </button>
        );
      })}
    </span>
  );
};

export const WbCheck = ({ k, label }) => {
  const { values, set, editable } = useWorkbook();
  const on = Boolean(values[k]);
  return (
    <button type="button" disabled={!editable} onClick={() => set(k, !on)} data-testid={`wb-${k}`} className="inline-flex items-center gap-2 text-sm text-slate-600">
      <span className={`inline-flex h-4 w-4 items-center justify-center rounded-[3px] border text-[10px] ${on ? "border-[#1F4266] bg-[#1F4266] text-white" : "border-slate-400"}`}>{on ? "✓" : ""}</span>
      {label}
    </button>
  );
};
